import moment from "moment";
moment.locale("es-mx");
const FormatDateIngreso = ({ dateOfAdmission, FechaIngreso }: any) => {
  const dateFormat = moment.utc(dateOfAdmission).format("L");
  return <span>{dateOfAdmission ? dateFormat : ""}</span>;
};

export default FormatDateIngreso;